import React, { useContext } from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthProvider/AuthProvider";

const DisplayError = () => {
  const { logOut } = useContext(AuthContext);
  const error = useRouteError();
  const navigate = useNavigate();

  const handleLogOut = () => {
    logOut()
      .then(() => {
        navigate("/login");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="notfound d-flex flex-column justify-content-center align-items-center">
      <div className="notfound-404">
        <h1 className="text-danger fw-bold">Oops!</h1>
      </div>
      <h2 className="text-[22px] fw-semibold text-warning mt-3 text-center">
        Something went Wrong!!!
      </h2>
      <p className="text-[16px] font-semibol mt-4 text-center">
        <button className="bg-danger px-3 py-2 rounded-4 fw-semibold text-white">
          {" "}
          {error.statusText || error.message}
        </button>
      </p>
      <div className="text-center mt-2">
        <span className="mx-2">Please</span>
        <button className="btn btn btn-outline-danger" onClick={handleLogOut}>
          Log Out
        </button>
        <span className="mx-2">and Sign in again</span>
      </div>
    </div>
  );
};

export default DisplayError;
